import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { AccountPanel } from "@cms/ui/components/account-panel";
import type { ClientOutletContext } from "../lib/outlet-context";

export function AccountPage() {
  const { userEmail, changePassword, setBreadcrumbs } = useOutletContext<ClientOutletContext>();

  useEffect(() => {
    setBreadcrumbs?.([{ label: "My account" }]);
    return () => setBreadcrumbs?.(null);
  }, [setBreadcrumbs]);

  return <AccountPanel email={userEmail} onChangePassword={changePassword} />;
}
